export const usersManageRoutes: AdminRoutes[] = [
  { to: '/admin/users/', content: 'Manage users' },
  { to: '/admin/users/data-copy-requests', content: 'Copy of Profile Data' },
];
